import { Link, useNavigate} from 'react-router-dom';
import { useStateContext } from 'shared/contexts/ContextProvider';
import { BASE_URL } from 'shared/config';


const itemItem = ({ item }) => {
  // Formatting the dates and time
  const formatDate = (date) => new Date(date).toLocaleDateString();
  const formatTime = (time) =>
    new Date(time).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    });

    const navigate = useNavigate();
  const { showToast } = useStateContext();
  const archiveitem = async (id, is_archived) => {
      const confirmArchive = window.confirm('Are you sure you want to archive this banner?');
      if (confirmArchive) {
        try {
          const url = `${BASE_URL}/admin-api/items`; 
          const token = 'token'; 

          const formData = new FormData();
          formData.append('id', id);
          formData.append('is_archived', is_archived);
          
          const response = await fetch(url, {
            method: 'PUT', 
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          });
    
          if (response.ok) {
            showToast({ title: 'Success!', content: 'item has been successfully archived.', cssClass: 'e-toast-success', icon: 'e-success toast-icons' });
            navigate(is_archived ? '/company/items/archived' : '/company/items/'); 
          } else {
            const errorData = await response.json();
            showToast({ title: 'Error!', content: errorData.message || 'Could not archive banner.', cssClass: 'e-toast-danger', icon: 'e-error toast-icons' });
          }
        } catch (error) {
          console.error('Fetch error:', error);
          showToast({ title: 'Error!', content: 'Failed to communicate with server.', cssClass: 'e-toast-danger', icon: 'e-error toast-icons' });
        }
      }
    };

  return (
    <div className='bg-gray-200 hover:bg-gray-100 rounded-lg shadow-lg overflow-hidden my-4 flex md:flex-row flex-col'>
      <img
        className='md:flex-shrink-0 w-full md:w-48 h-48 object-cover'
        src={item.image_url}
        alt={item.name}
      />
      <div className='flex flex-col justify-between'>
        <div>
          <div className='text-lg font-semibold'>{item.name}</div>
          <div className='text-sm text-gray-600'>{item.group ? item.group.name: ' - '}</div>
          <div className='text-sm text-gray-600'>{item.email}</div>
          <div className='text-sm text-gray-600'>{item.phone}</div>
          <div className='text-sm text-gray-600'>
            Created: {formatDate(item.created)}
          </div>
          <div className='text-sm text-gray-600'>
            Updated: {formatDate(item.updated)}
          </div>
          <div className='text-sm text-gray-600'>
            Last Seen: {formatTime(item.last_seen)}
          </div>
        </div>
        <div className='flex mt-4'>
          <Link
            to={'/company/items/' + item.id + '/edit/'}
            className='text-blue-600 hover:underline mr-2'
          >
            Изменить
          </Link>
          <button onClick={() => archiveitem(item.id, !item.is_archived)}>
            {item.is_archived ? 'Восстановить' : 'В архив'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default itemItem;
